import React, { useState, useEffect } from 'react';
import { IoMdCreate } from 'react-icons/io';
import { IoWarning } from 'react-icons/io5';
import { FaThumbsUp, FaCheckCircle } from 'react-icons/fa';
import { GrDrag } from 'react-icons/gr';

const statusOptions = [
    { value: 'Off Track', label: 'Off Track', icon: <IoWarning style={{ color: 'red', fontSize: '20px' }} /> },
    { value: 'On Track', label: 'On Track', icon: <FaThumbsUp style={{ color: '#48994B', fontSize: '20px' }} />  },
    { value: 'Complete', label: 'Complete', icon:<FaCheckCircle style={{ color: '#2F8DAC', fontSize: '20px' }} /> },
];

const CustomDropdown = ({ options, selectedValue, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleOptionClick = (option) => {
        onChange(option.value);
        setIsOpen(false);
    };

    return (
        <div style={{ position: 'relative' }}>
            <div
                onClick={() => setIsOpen(!isOpen)}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                    padding: '5px',
                    borderRadius: '4px',
                }}
            >
                {options.map((option) => (
                    option.value === selectedValue && (
                        <span key={option.value} style={{ display: 'flex', alignItems: 'center' }}>
                            {option.icon}
                        </span>
                    )
                ))}
            </div>
            {isOpen && (
                <div style={{
                    position: 'absolute',
                    top: '100%',
                    left: 0,
                    right: 0,
                    background: 'white',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    zIndex: 1000,
                    width: '8vw',
                    padding: '12px'
                }}>
                    {options.map((option) => (
                        <div
                            key={option.value}
                            onClick={() => handleOptionClick(option)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '10px',
                                cursor: 'pointer',
                                '&:hover': { backgroundColor: '#f0f0f0' },
                            }}
                        >
                            <span style={{ marginRight: '8px' }}>{option.label}</span>
                            {option.icon}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

const CompanyRocks = ({ initialData, onStatusChange, onTitleChange, onRowOrderChange }) => {
    const [dummyData, setDummyData] = useState(initialData);

    useEffect(() => {
        setDummyData(initialData);
    }, [initialData]);



    const handleDragEnd = (newOrder) => {
        onRowOrderChange(newOrder);
    };

    const defaultData = [
        { id: 1, status: 'On Track', title: "We love to create those as", owner: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIGKcO47FJXGbn-gnAsAn4Ad88cJxHeoQqnpyaVXeiMyTRnuk7IfqSvDmQpWJvoL5sR1Q&usqp=CAU" },
        { id: 2, status: 'Complete', title: "Development & Acquisition", owner: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ4mfcCBaUG6YTp9y_QD0OBm9SVoPZjj_hjT2CQhq17whHvcttXcBJh1nPf-7N-tu-hTAk&usqp=CAU" },
        { id: 3, status: 'Off Track', title: "This means we consistently", owner: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQphnRKlyvM_8IVmb89zy638Y_uStmu75bSc6YDmdMX32iABjxadlXv2qzT4l56zta0w84&usqp=CAU" },
        { id: 4, status: 'On Track', title: 'Project Delta', owner: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTIGKcO47FJXGbn-gnAsAn4Ad88cJxHeoQqnpyaVXeiMyTRnuk7IfqSvDmQpWJvoL5sR1Q&usqp=CAU' },
    ];

    const [editingRowId, setEditingRowId] = useState(null);
    const [newTitle, setNewTitle] = useState('');
    const [hoveredRowId, setHoveredRowId] = useState(null);
    const [draggedRowId, setDraggedRowId] = useState(null);

    useEffect(() => {
        if (initialData && initialData.length > 0) {
            setDummyData(initialData);
        }
    }, [initialData]);

    const handleStatusChange = (id, newStatus) => {
        setDummyData((prevData) =>
            prevData.map((row) => (row.id === id ? { ...row, status: newStatus } : row))
        );
        onStatusChange(id, newStatus);
    };
    // const handleStatusChange = (id, newStatus) => {
    //     onStatusChange(id, newStatus);
    // };

    const handleEditClick = (row) => {
        setEditingRowId(row.id);
        setNewTitle(row.title);
    };

    // const handleTitleChange = (id, newTitle) => {
    //     onTitleChange(id, newTitle);
    // };

    const handleTitleChange = (id) => {
        setDummyData((prevData) =>
            prevData.map((row) => (row.id === id ? { ...row, title: newTitle } : row))
        );
        setEditingRowId(null);
        onTitleChange(id, newTitle);
    };

    const handleDragStart = (id) => {
        setDraggedRowId(id);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDrop = (id) => {
        const draggedOverItem = dummyData.find(item => item.id === id);
        const draggedItem = dummyData.find(item => item.id === draggedRowId);

        if (draggedOverItem && draggedItem) {
            const newData = dummyData.filter(item => item.id !== draggedRowId);
            const index = newData.indexOf(draggedOverItem);
            newData.splice(index, 0, draggedItem);
            setDummyData(newData);
        }
        setDraggedRowId(null);
    };

    return (
        <div className="box-title1 d-flex flex-column align-items-start">
            <h4 className="m-2" style={{ marginRight: '8px' }}>
                Company Rocks
            </h4>

            <table className="table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                <thead>
                    <tr>
                        <th style={{ width: '20px', borderRight: '1px solid #ccc', padding: '8px' }}></th>
                        <th style={{ width: '40px', borderRight: '1px solid #ccc', padding: '8px' }}>Status</th>
                        <th style={{ border: '1px solid #ccc', padding: '8px' }}>Title</th>
                        <th style={{ width: '80px', borderRight: '1px solid #ccc', padding: '8px' }}>Owner</th>
                    </tr>
                </thead>
                <tbody>
                    {dummyData.map((row) => (
                        <tr
                            key={row.id}
                            className='p-2'
                            onMouseEnter={() => setHoveredRowId(row.id)}
                            onMouseLeave={() => setHoveredRowId(null)}
                            draggable
                            onDragStart={() => handleDragStart(row.id)}
                            onDragOver={handleDragOver}
                            onDrop={() => handleDrop(row.id)}
                            style={{
                                transition: 'background-color 0.3s ease',
                                backgroundColor: hoveredRowId === row.id ? '#f9f9f9' : 'white',
                                borderBottom: '1px solid #ccc',
                            }}
                        >
                            <td className='p-2' style={{ width: '20px', border: '0px solid #ccc', padding: '8px', cursor: 'grab' }}>
                                <GrDrag style={{ fontSize: '15px', color: '#888' }} />
                            </td>
                            <td className='p-2' style={{ width: '40px', border: '0px solid #ccc', padding: '8px' }}>
                                <CustomDropdown
                                    className='company-rock-select'
                                    options={statusOptions}
                                    selectedValue={row.status}
                                    onChange={(newStatus) => handleStatusChange(row.id, newStatus)}
                                />
                            </td>
                            <td className='p-2' style={{ position: 'relative', display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '0px solid #ccc', padding: '8px' }}>
                                {editingRowId === row.id ? (
                                    <input
                                        type="text"
                                        value={newTitle}
                                        onChange={(e) => setNewTitle(e.target.value)}
                                        onBlur={() => handleTitleChange(row.id)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                handleTitleChange(row.id);
                                            }
                                        }}
                                        style={{ flex: 1, marginRight: '8px' }}
                                    />
                                ) : (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div>{row.title}</div>
                                        {hoveredRowId === row.id && (
                                            <IoMdCreate
                                                onClick={() => handleEditClick(row)}
                                                style={{
                                                    textAlign: 'center',
                                                    fontSize: '20px',
                                                    cursor: 'pointer',
                                                    marginLeft: '5px',
                                                }}
                                            />
                                        )}
                                    </div>
                                )}
                            </td>
                            <td className='p-2' style={{ width: '80px', border: '0px solid #ccc', padding: '8px' }}>
                                <img
                                    src={row.owner}
                                    alt="Owner"
                                    style={{ width: '30px', height: '30px', borderRadius: '50%' }}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CompanyRocks;